export default {
  title: "Suporte",
  rules: {
    note: "Antes de enviar uma solicitação, por favor, leia as regras:",
    rule_1: "1. Primeiro, consulte a seção de {faq} (FAQ) — talvez a resposta já esteja lá.",
    rule_2: "2. Em caso de problemas com pagamento, inclua obrigatoriamente os detalhes da transação (data, valor, método de pagamento, capturas de tela).",
    rule_3: "3. Em caso de problemas para baixar arquivos, inclua obrigatoriamente os links desses arquivos.",
    rule_4: "4. Para questões de direitos autorais ou quaisquer outros arquivos que violem as regras, entre em contato: {email}",
    rule_5: "5. Para cooperação, programas de afiliados, publicidade e outras propostas comerciais, escreva para: {email}",
    rule_6: "6. A resposta pode levar de 12 horas a até 2 dias úteis, dependendo da complexidade da solicitação e da carga do suporte.",
    rules: "regras",
    faq: "perguntas frequentes"
  },
  messages: {
    note: "*Exibindo as últimas {count} mensagens",
    you: "Você",
    support: "Suporte",
    autoanswer_subject_is_over: "A conversa foi encerrada porque o seu problema foi resolvido.\nAgradecemos por entrar em contato com o suporte."
  },
  inputs: {
    message: {
      placeholder: "Escreva sua pergunta"
    },
    attachments: {
      btn: "{text} {formats}",
      attach_file: "Anexar arquivo",
      attached_files: "Arquivos anexados:"
    }
  },
  errors: {
    generic: "Erro",
    invalid_file_type: "Formato de arquivo não suportado.",
    max_file_size_limit: "O arquivo é muito grande. Escolha um arquivo menor.",
    filename_too_long: "O nome do arquivo é muito longo",
    filename_invalid_chars: "O nome do arquivo contém caracteres inválidos"
  },
  btn: {
    send: "Enviar"
  }
};
